import { styled } from 'styled'

import Text from './Text'

export default styled(Text).attrs({ block: true })``
